import React from "react";
import { Loadable, IRouteItem } from "@techzyapp/ui-lib";
import {
  CASHBACK_PAGE_PATH,
  CASHBACK_PAGE_ADD_PATH,
  CASHBACK_PAGE_UPDATE_PATH,
} from "utils/constants/paths";

const CashbackDetailsPage = Loadable(React.lazy(() => import("./View")));
const CashbackDetailsPageAddOrUpdate = Loadable(
  React.lazy(() => import("./View/AddOrUpdate")),
);

export const CashbackRoute: IRouteItem = {
  path: CASHBACK_PAGE_PATH,
  element: React.createElement(CashbackDetailsPage),
  name: "Cashback Listing",
  children: [
    {
      name: "Add / Update",
      path: CASHBACK_PAGE_ADD_PATH,
      element: React.createElement(CashbackDetailsPageAddOrUpdate),
      showInDrawer: false,
    },
    {
      path: CASHBACK_PAGE_UPDATE_PATH,
      element: React.createElement(CashbackDetailsPageAddOrUpdate),
      showInDrawer: false,
    },
  ],
};
